

















































































































import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import Component from 'vue-class-component'
import {
  RuleEngineCondition,
  RuleEngineFact,
  RuleConditionType,
  Branch,
  RuleEngineOperator,
  RuleFactType
} from '../utils/types'
import DatePicker from './DatePicker.vue'
import { Getter } from 'vuex-class'

@Component({
  name: 'RuleCondition',
  components: { DatePicker }
})
export default class RuleCondition extends Vue {
  @Getter branches!: Branch[]
  @Prop(Object) condition!: RuleEngineCondition
  @Prop(Array) facts!: RuleEngineFact[]
  @Prop(Array) operators!: RuleEngineOperator[]
  @Prop(Boolean) multiple!: false

  factType = RuleFactType
  ruleConditionType = RuleConditionType

  private get currentFactType () {
    return (
      this.facts.find(fact => fact.id === this.condition.fact)?.type ??
      RuleFactType.BOOLEAN
    )
  }

  private get selectableBranches () {
    return this.branches.map(branch => ({
      text: branch.name,
      value: branch.id
    }))
  }

  private get selectableFacts () {
    return this.facts.map(fact => ({ text: fact.name, value: fact.id }))
  }

  private get timeString (): string {
    return this.condition.compareValue?.split('T')[1] || ''
  }

  private set timeString (value: string) {
    this.condition.compareValue = `1970-01-01T${value}`
  }

  addChildClicked (condition: RuleEngineCondition) {
    this.$emit('addChildClick', condition)
  }

  conditionTypeClicked (
    condition: RuleEngineCondition,
    type: RuleConditionType
  ) {
    type !== condition.type &&
      this.$emit('conditionTypeClick', condition, type)
  }

  removeChildClicked (condition: RuleEngineCondition, childIndex: number) {
    this.$emit('removeChildClick', condition, childIndex)
  }

  selectableOperators () {
    return this.operators
      .filter(operator => operator.for === this.currentFactType)
      .map(operator => ({
        text: operator.name,
        value: operator.id
      }))
  }
}
